import { Context } from '@sentry/browser';
import { getSessionParams } from './get-url-params';

interface ClientContext extends Context {
  userAgent: string;
  browserLanguage: string;
  platform: string;
  referrer: string;
  instance: string;
  stageUuid: string;
  versionHash: string;
  pathUuid: string;
  brand: string;
  tags: string;
  isFromHub: boolean;
  isAdmin: boolean;
  hubGameUuid: string;
  gameLanguage: string;
  backgroundColor: string;
}

export function getClientContext(): ClientContext {
  const {
    instance,
    stageUuid,
    versionHash,
    pathUuid,
    brand,
    tags,
    isFromHub,
    isAdmin,
    hubGameUuid,
    language,
    bg,
  } = getSessionParams();

  return {
    userAgent: navigator.userAgent,
    browserLanguage: navigator.language,
    platform: navigator.platform,
    referrer: document.referrer,
    instance,
    stageUuid,
    versionHash,
    pathUuid,
    brand,
    tags,
    isFromHub,
    isAdmin,
    hubGameUuid,
    gameLanguage: language,
    backgroundColor: bg,
  };
}
